import { getSpacing, defaults } from './space.esm.js';
import { system } from './system-core.esm.js';

var config = {
  gap: {
    property: 'gap',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  rowGap: {
    property: 'rowGap',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
};
config.gridGap = config.gap;
config.gridColumnGap = config.columnGap;
config.gridRowGap = config.rowGap;
var grid = system(config);

export default grid;
export { grid };
//# sourceMappingURL=grid.esm.js.map
